import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { AUTH_URL } from "../../../utils/constants";
import { useAuth } from "../../../utils/AuthContext";
import { Category } from "@mui/icons-material";
import chatIcon from "../../../assets/images/3p.png";
import bgImage from "../../../assets/images/background1.png";
import vector1 from "../../../assets/images/vector.svg";
import vector2 from "../../../assets/images/vector2.svg";


const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState({ email: "", password: "" });
  const { login } = useAuth();
  const [user, setUser] = useState("user");
  const [showPassword, setShowPassword] = useState(false);


  const loginUser = (response) => {
    console.log(response, "line15");
    // sessionStorage.setItem("email", email);
    // sessionStorage.setItem("userId", response?.data?.id);
    // sessionStorage.setItem("name", response?.data?.name);
    const userData = {
      email: email,
      userId: response?.data?.id,
      name: response?.data?.name,
      role: response?.data?.role,
    };
    login(userData);
    navigate("/botDesk");
  }

  const handleValidation = () => {
    let isValid = true;
    let newError = { email: "", password: "" };

    // Email validation
    if (!email.trim()) {
      newError.email = "Email is required.";
      isValid = false;
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    ) {
      newError.email = "Please enter a valid email address.";
      isValid = false;
    }

    // Password validation
    if (!password.trim()) {
      newError.password = "Password is required.";
      isValid = false;
    }

    setError(newError);
    return isValid;
  };

  const handleLogin = async () => {
    if (handleValidation()) {
      // Clear errors and navigate if validation passes
      try {
        if (user === "officer") {
          let response = await axios.post(
            `${AUTH_URL}expertlogin`,
            { email: email, password: password },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (response?.data) {
            const userData = {
              email: email,
              userId: response?.data?.id,
              name: response?.data?.name,
              role: response?.data?.role,
              category: response?.data?.officer_cag_category,
            };
            login(userData);
            navigate("/officerDesk");
          }
        }
        else if (user === "admin") {
          let response = await axios.post(
            `${AUTH_URL}adminlogin`,
            { email: email, password: password },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (response?.data) {
            const userData = {
              email: email,
              userId: response?.data?.id,
              name: response?.data?.name,
              role: response?.data?.role,

            };
            login(userData);
            navigate("/adminDesk");
          }
        }

        else {
          let response = await axios.post(
            `${AUTH_URL}usersignin`,
            { email: email, password: password },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
          if (response.status === 200) {
            loginUser(response)
          } else {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: `${response?.data?.message}`,
            });
          }
        }

      } catch (error) {
        console.log("Error in login api", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Error in Login Api",
        });
      }
      // navigate("/Desk");
      setError({ email: "", password: "" });
    }
  };

  const handleNavigate = () => {
    // Navigate to New User Registration
    navigate("/Register");
  };

  return (
    <div className="w-full h-full flex" style={{
      backgroundImage: `url(${bgImage})`,
      backgroundSize: "130% 130%",
      backgroundPosition: "right bottom"
    }}>
      <div className="hidden md:flex w-[50%] flex-col items-center justify-center">
        <img src={vector2} alt="" className="w-[45%] " />
        {/* <img src={vector1} alt="" className="w-[35%]" /> */}
      </div>
      <div className="w-full md:w-[50%]">
        <div className="w-full h-full flex flex-col justify-center items-center px-4">
          <div
            className="w-full max-w-md bg-white rounded-lg shadow-[0_4px_6px_-4px_rgba(0,0,0,0.1),_0_10px_15px_-3px_rgba(0,0,0,0.1)] flex flex-col relative z-10"
            style={{ padding: 'min(3vh, 1.5rem)', gap: 'min(1.5vh, 0.75rem)' }}
          >
            {/* --- Header Section --- */}
            <div className="flex flex-col shrink-0 items-center justify-center" style={{ gap: 'min(0.5vh, 0.25rem)' }}>
              <h2 className="text-center font-semibold text-black" style={{ fontSize: 'min(2.5vh, 1.25rem)', lineHeight: 1.2 }}>
                Identity Authentication
              </h2>
              <p className="text-center text-gray-500" style={{ fontSize: 'min(1.8vh, 0.875rem)', lineHeight: 1.2 }}>
                Select your portal to begin the secure session.
              </p>
            </div>

            {/* --- Tabs --- */}
            <div className="w-full bg-[#F3F4F6] rounded-lg flex items-center justify-between font-semibold cursor-pointer border border-gray-200 shrink-0"
              style={{ padding: 'min(0.5vh, 0.25rem)' }}>
              <div
                onClick={() => setUser("user")}
                className={`flex-1 text-center rounded-md transition-all ${user === "user" ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white shadow" : "text-gray-600 hover:text-gray-900"}`}
                style={{ padding: 'min(1vh, 0.5rem)', fontSize: 'min(1.8vh, 0.875rem)' }}
              >
                User Login
              </div>
              <div
                onClick={() => setUser("officer")}
                className={`flex-1 text-center rounded-md transition-all ${user === "officer" ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white shadow" : "text-gray-600 hover:text-gray-900"}`}
                style={{ padding: 'min(1vh, 0.5rem)', fontSize: 'min(1.8vh, 0.875rem)' }}
              >
                Officer Login
              </div>
              <div
                onClick={() => setUser("admin")}
                className={`flex-1 text-center rounded-md transition-all ${user === "admin" ? "bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white shadow" : "text-gray-600 hover:text-gray-900"}`}
                style={{ padding: 'min(1vh, 0.5rem)', fontSize: 'min(1.8vh, 0.875rem)' }}
              >
                Admin Login
              </div>
            </div>

            {/* --- Form Section --- */}
            <div className="w-full flex flex-col justify-center shrink-0" style={{ gap: 'min(1.5vh, 0.75rem)' }}>

              {/* Email */}
              <div className="w-full" style={{ gap: 'min(0.5vh, 0.25rem)', display: 'flex', flexDirection: 'column' }}>
                <label className="font-medium text-gray-700" style={{ fontSize: 'min(1.8vh, 0.875rem)' }}>
                  Email ID<span className="text-red-500">*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={`w-full border ${error.email ? "border-red-500 focus:ring-red-300" : "border-gray-300 focus:ring-teal-500"} rounded-md bg-white focus:outline-none focus:ring-2 transition px-3`}
                  style={{ paddingBlock: 'min(1vh, 0.5rem)', fontSize: 'min(1.8vh, 0.875rem)' }}
                />
                {error.email && <p className="text-red-500 mt-1" style={{ fontSize: 'min(1.5vh, 0.75rem)' }}>{error.email}</p>}
              </div>

              {/* Password */}
              <div className="w-full" style={{ gap: 'min(0.5vh, 0.25rem)', display: 'flex', flexDirection: 'column' }}>
                <label className="font-medium text-gray-700" style={{ fontSize: 'min(1.8vh, 0.875rem)' }}>
                  Password <span className="text-red-500">*</span>
                </label>
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`w-full border ${error.password ? "border-red-500 focus:ring-red-300" : "border-gray-300 focus:ring-teal-500"} rounded-md bg-white focus:outline-none focus:ring-2 transition px-3`}
                  style={{ paddingBlock: 'min(1vh, 0.5rem)', fontSize: 'min(1.8vh, 0.875rem)' }}
                />

                <div className="flex items-center" style={{ marginTop: 'min(0.5vh, 0.25rem)' }}>
                  <input
                    id="show-password"
                    type="checkbox"
                    checked={showPassword}
                    onChange={(e) => setShowPassword(e.target.checked)}
                    className="text-[#00B8DB] focus:ring-[#00B8DB] border-gray-300 rounded cursor-pointer"
                    style={{ width: 'min(2vh, 1rem)', height: 'min(2vh, 1rem)' }}
                  />
                  <label htmlFor="show-password" className="ml-2 text-gray-600 cursor-pointer" style={{ fontSize: 'min(1.8vh, 0.875rem)' }}>
                    Show password
                  </label>
                </div>
                {error.password && <p className="text-red-500 mt-1" style={{ fontSize: 'min(1.5vh, 0.75rem)' }}>{error.password}</p>}
              </div>

              {/* Submit Button */}
              <button
                onClick={handleLogin}
                className="w-full bg-gradient-to-r from-[#45B07B] to-[#12A57C] text-white rounded-md hover:opacity-95 transition font-medium shadow-md"
                style={{ paddingBlock: 'min(1.5vh, 0.625rem)', marginTop: 'min(0.5vh, 0.25rem)', fontSize: 'min(2vh, 1rem)' }}
              >
                Log In
              </button>
            </div>

            {/* --- Footer Extra Options --- */}
            <div className="w-full flex shrink-0" style={{ gap: 'min(1.5vh, 0.75rem)', marginTop: 'min(0.5vh, 0.25rem)' }}>
              <div
                onClick={handleNavigate}
                className="flex-1 bg-white hover:bg-gray-50 border border-gray-200 rounded-lg font-medium text-[#1447E6] transition-colors text-center flex items-center justify-center cursor-pointer shadow-sm"
                style={{ paddingBlock: 'min(1vh, 0.5rem)', fontSize: 'min(1.8vh, 0.875rem)' }}
              >
                New User?
              </div>
              <div
                onClick={() => navigate("/faq")}
                className="flex-1 bg-white hover:bg-gray-50 border border-gray-200 rounded-lg font-medium text-gray-700 transition-colors flex flex-col items-center justify-center text-center cursor-pointer shadow-sm"
                style={{ paddingBlock: 'min(0.5vh, 0.25rem)' }}
              >
                <span className="font-semibold text-gray-800" style={{ fontSize: 'min(1.8vh, 0.875rem)' }}>FAQs</span>
                <span className="text-gray-500" style={{ fontSize: 'min(1.2vh, 0.625rem)' }}>24/7 Citizen Support</span>
              </div>
            </div>

            <p className="text-center text-gray-500 shrink-0" style={{ fontSize: 'min(1.5vh, 0.75rem)', marginTop: 'min(0.5vh, 0.25rem)' }}>
              By signing in, you accept the Terms and Conditions.
            </p>
          </div>
        </div>




        {/* Officer Login */}

      </div>
    </div>

  );
};

export default Login;
